<template>
  <v-card class="mt-5 rounded-card card-shadow">
    <div class="pa-2">
      <small>{{ oferta.titulo }} / {{ oferta.codigo }} ({{ oferta.categoria.descricao }})</small>
      <div>
        <v-row dense>
          <v-col cols="12" sm="3">
            <px-input-money
              dense
              ref="precoAVista"
              class="required"
              label="Preço à vista"
              :error="$v.variacaoPadrao.precoAVista.$error"
              @blur="$v.variacaoPadrao.precoAVista.$touch()"
              v-model="variacaoPadrao.precoAVista"/>
          </v-col>
          <v-col cols="12" sm="3">
            <px-input-money
              dense
              ref="precoAPrazo"
              class="required"
              label="Preço a prazo"
              :error="$v.variacaoPadrao.precoAPrazo.$error"
              @blur="$v.variacaoPadrao.precoAPrazo.$touch()"
              v-model="variacaoPadrao.precoAPrazo"/>
          </v-col>
          <v-col cols="12" sm="3">
            <px-input-number :label="`Quantidade mínima (em ${oferta.unidadeMedida.descricao})`"
                             required
                             dense
                             class="required"
                             autocomplete="off"
                             :error="$v.variacaoPadrao.quantidade.$error"
                             @blur="$v.variacaoPadrao.quantidade.$touch()"
                             v-model="variacaoPadrao.quantidade"/>
          </v-col>
          <v-col cols="12" sm="3" v-if="!isSmall">
            <v-btn color="primary"
                   :loading="loadingCadastro"
                   @click="onClickSave">
              Salvar
            </v-btn>
            <v-btn icon class="ml-2" @click="goToEditOferta">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <px-input-percentage
              dense
              label="Percentual de desconto"
              class="required"
              :error="$v.oferta.promocao.percentualDesconto.$error"
              @blur="$v.oferta.promocao.percentualDesconto.$touch()"
              v-model="oferta.promocao.percentualDesconto"/>
          </v-col>
          <v-col cols="12" sm="3">
            <px-date-picker label="Data limite"
                            dense
                            clearable
                            :error="$v.promocaoData.$error"
                            @blur="$v.promocaoData.$touch()"
                            v-model="promocaoData"/>
          </v-col>
          <v-col cols="12" sm="3">
            <px-input-time dense
                           :error="$v.promocaoHora.$error"
                           @blur="$v.promocaoHora.$touch()"
                           v-model="promocaoHora"/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-switch
              dense
              hide-details
              class="switch-dense"
              v-model="oferta.promocao.ativo"
              label="Promoção ativa"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-switch
              hide-details
              class="switch-dense"
              v-model="oferta.ativo"
              label="Oferta ativa"
            ></v-switch>
          </v-col>
          <v-col cols="12" sm="4">
            <v-switch
              hide-details
              class="switch-dense"
              v-model="oferta.disponivel"
              label="Disponível"
            ></v-switch>
          </v-col>
          <v-col cols="12" sm="4">
            <v-switch
              hide-details
              class="switch-dense"
              v-model="oferta.destaque"
              label="Destacar oferta"
            ></v-switch>
          </v-col>
          <v-col cols="12" v-if="isSmall">
            <v-btn color="primary" small
                   :loading="loadingCadastro"
                   @click="onClickSave">
              Salvar
            </v-btn>
            <v-btn icon small class="ml-2" @click="goToEditOferta">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-card>
</template>

<script>
import { validateHours } from '@/utils/validations';
import validationMixin from '@/mixins/validation-mixin';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { NumberUtils } from 'px-components';
import { cloneDeep, first, last } from 'lodash';
import OfertaService from '@/modules/marketplace/ofertas/oferta-service';

export default {
  mixins: [validationMixin],
  props: {
    oferta: Object,
  },
  data() {
    return {
      promocaoHora: null,
      promocaoData: null,
      loadingCadastro: null,
      variacaoPadrao: {
        precoAVista: null,
        precoAPrazo: null,
        quantidade: null,
      },
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    goToEditOferta() {
      this.$router.push({
        name: 'main.marketplace.oferta.edicao',
        params: {
          id: this.oferta.id,
        },
      });
    },
    setupEditingObject() {
      this.variacaoPadrao = first(this.oferta.variacoes);

      this.variacaoPadrao.precoAVista = NumberUtils.fixNumberInput(this.variacaoPadrao.precoAVista);
      this.variacaoPadrao.precoAPrazo = NumberUtils.fixNumberInput(this.variacaoPadrao.precoAPrazo);
      this.oferta.promocao.percentualDesconto = NumberUtils
        .fixNumberInput(this.oferta.promocao.percentualDesconto, true);

      if (this.oferta.promocao && this.oferta.promocao.dataLimite) {
        const dataHora = this.oferta.promocao.dataLimite.split('T');
        this.promocaoData = first(dataHora);
        this.promocaoHora = last(dataHora)
          .slice(0, 5);
      }
    },
    getDataHoraPromocao() {
      if (this.promocaoHora && this.promocaoData) {
        return `${this.promocaoData}T${this.promocaoHora}`;
      }
      return null;
    },
    buildOferta() {
      const oferta = cloneDeep(this.oferta);
      oferta.titulo = this.oferta.titulo.toUpperCase();
      oferta.promocao.dataLimite = this.getDataHoraPromocao();
      oferta.variacoes = [this.variacaoPadrao];
      return oferta;
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.loadingCadastro = true;
      OfertaService.save(this.buildOferta())
        .then(() => {
          this.$toast('Oferta salva', { color: 'success' });
          this.$emit('change');
        })
        .finally(() => {
          this.loadingCadastro = false;
        });
    },
  },
  created() {
    this.setupEditingObject();
  },
  validations: {
    promocaoHora: {
      validateHours,
      required: requiredIf(function () {
        return this.promocaoData;
      }),
    },
    promocaoData: {
      required: requiredIf(function () {
        return this.promocaoHora;
      }),
    },
    variacaoPadrao: {
      precoAVista: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
      precoAPrazo: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
      quantidade: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
    },
    oferta: {
      configuracaoVenda: {
        required,
      },
      categoria: {
        required,
      },
      titulo: {
        required,
      },
      codigo: {
        required,
      },
      especificacao: {
        required,
      },
      unidadeMedida: {
        required,
      },
      promocao: {
        percentualDesconto: {
          required: requiredIf(function () {
            return !this.oferta.promocao.ativo;
          }),
          minValue(value, data) {
            return data.ativo ? value > 0 : true;
          },
        },
      },
    },
  },

};
</script>
